module.exports = __webpack_public_path__ + "static/media/coinbase-new-form.8a5f2302.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coinbase-new-form.png
// module id = 58
// module chunks = 0